// noinspection JSDeprecatedSymbols

const getPlatform = (): string | undefined => {
    return navigator?.userAgentData?.platform || navigator?.platform || undefined;
}

export default getPlatform;